<script setup lang="ts">
import { makeFirstLetterUpper } from '@/utils/main';
import { addMonths, format, subMonths } from 'date-fns';
import { ru } from 'date-fns/locale';
import { ref } from 'vue';
import store from '@/store';
import { reachGoal } from '@/utils/metrika';

defineProps<{
  isOpen: boolean;
}>();

const reportInProcess = ref<boolean>(false);

const currentDate = new Date();

// Генерация месяцев (предыдущий, текущий, следующий)
const months = [
  makeFirstLetterUpper(format(subMonths(currentDate, 1), 'LLLL', { locale: ru })),
  makeFirstLetterUpper(format(currentDate, 'LLLL', { locale: ru })),
  makeFirstLetterUpper(format(addMonths(currentDate, 1), 'LLLL', { locale: ru })),
];

// Генерация дат в формате YYYY-MM-DD (предыдущий, текущий, следующий)
const dates = [
  format(subMonths(currentDate, 1), 'yyyy-MM-01'),
  format(currentDate, 'yyyy-MM-01'),
  format(addMonths(currentDate, 1), 'yyyy-MM-01'),
];

// Суффиксы для цели метрики по индексу месяца (предыдущий, текущий, следующий)
const monthGoalSuffixes = ['prev', 'current', 'next']

// Обработка нажатия на ссылку
const getReportLink = async (startDate: string, monthIndex: number) => {
  try {
    reportInProcess.value = true;
    const url = await store.dispatch("data/getFRVReport", startDate)
    downloadReportFile(url)
    reachGoal(`sidenav-report-download-${monthGoalSuffixes[monthIndex]}`)
  } catch (error) {
    console.error(error);
  } finally {
    setTimeout(() => reportInProcess.value = false, 200)
  }
}

// Создаем элемент из полученного URL для скачивания
const downloadReportFile = (url: string) => {
  if (url) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.click();
    link.remove();
  }
}
</script>

<template>
  <ul v-if="isOpen">
    <li v-for="(month, index) in months" :key="index">
      <a href="#" @click.prevent="getReportLink(dates[index], index)" :class="{'disabled' : reportInProcess}"
         data-qa="report-drop-link-download">{{ month }}</a>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
ul {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
}

a {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  transition: all .3s;
  text-decoration: none;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: #000000;
  height: 38px;

  &.disabled {
    opacity: .4;
    pointer-events: none;
    cursor: default;
  }

  &:hover {
    text-decoration: none;
    background-color: #F9F9F9;
  }
}
</style>